import RarityWhite from './imgs/rarity_white.png';
import RarityGreen from './imgs/rarity_green.png';
import RarityBlue from './imgs/rarity_blue.png';
import RarityGold from './imgs/rarity_gold.png';
import RarityPurple from './imgs/rarity_purple.png';

import './index.css';

const imageServer = process.env.REACT_APP_IMAGE_SERVER || 'https://ameriax.org/image_server/item_images';

const rarityImages = {
    1: RarityWhite,
    2: RarityGreen,
    3: RarityBlue,
    4: RarityGold,
    5: RarityPurple,
};

const rarityNames = {
    1: 'Common',
    2: 'Uncommon',
    3: 'Rare',
    4: 'Epic',
    5: 'Legendary',
}

const CharacterInventoryItemComponent = ({item}) => {

    return (
        <div id='cp-imgs-container'>
            {item.rarity ? <img className={`cp-item-rarity-img cp-item-rarity-img${item.pid}`} title={rarityNames[item.rarity]}
                src={rarityImages[item.rarity]}
                alt={rarityNames[item.rarity]}
            /> : ''}
            <img className={`character-profile-item${item.pid} character-profile-item-cn`}
                src={`${imageServer}/${item.itemtype}.gif`} 
                alt='item'
            />
        </div>
    );
};

export default CharacterInventoryItemComponent;